import React, { useEffect } from 'react';
import { useTranslation } from '../locale/useTranslation';
function Footer() {
  const { t, language, setLanguage } = useTranslation();
  useEffect(() => {
  }, []);

  return (
    <>
      <footer className="footer mt-auto" style={{backgroundColor: '#EE7203', height: "100%", overflow:'hidden'}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <div style={{flex: 1, width: '100%', textAlign:'center'}}>
            <p>{t("Besoin d'aide : ")}<a href={"mailto:" + process.env.REACT_APP_SUPPORT_EMAIL}>{process.env.REACT_APP_SUPPORT_EMAIL}</a><br />
              {
                process.env.REACT_APP_APP_VARIANT === "hyapp" ? <>{t("Conception et développement : ")}<a href="https://www.europe-internet.net" target="_blank" rel="noopener">Europe Internet</a></> : null
              } 
              
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;